import React from 'react'

const RecipeItemListHeaders = () => {

    return(
        <React.Fragment>
            <th>#</th>
            <th colSpan={4}>Stok Adı</th>
            <th>Miktar</th>
            <th>Birimi</th>
            <th>Birim Fiyatı</th>
            <th>Para Birimi</th>
            <th>Parite</th>
            <th>Toplam</th>
        </React.Fragment>
    )
}
export default RecipeItemListHeaders